import React from "react";
import { Box, Link } from "@mui/material";
import { colors, fonts, gradients, layout } from "../../theme/tokens";

const aboutImage =
  "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=1000&auto=format&fit=crop";

const About = () => {
  return (
    <Box
      component="section"
      sx={{ py: "56px", px: { xs: "20px", md: "28px" } }}
    >
      <Box
        sx={{
          maxWidth: layout.maxWidth,
          mx: "auto",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: ".92fr 1.08fr" },
          gap: { xs: "48px", md: "64px" },
          alignItems: "center",
        }}
      >
        {/* Image + badge */}
        <Box sx={{ position: "relative" }}>
          <Box
            component="img"
            src={aboutImage}
            alt="Advisory team"
            loading="lazy"
            sx={{
              width: "100%",
              height: { xs: "340px", md: "440px" },
              objectFit: "cover",
              borderRadius: "24px",
              display: "block",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: "-26px",
              right: { xs: "10px", md: "-22px" },
              background: gradients.amber,
              color: "#fff",
              borderRadius: "20px",
              p: "22px 26px",
              boxShadow: "0 26px 50px -22px rgba(242,121,28,.6)",
              maxWidth: "230px",
            }}
          >
            <Box
              sx={{
                fontFamily: fonts.display,
                fontWeight: 700,
                fontSize: "34px",
                lineHeight: 1,
              }}
            >
              100%
            </Box>
            <Box
              sx={{
                fontFamily: fonts.body,
                fontSize: "13.5px",
                mt: "4px",
                fontWeight: 500,
                opacity: 0.95,
              }}
            >
              Value-focused. Every engagement is measured by impact.
            </Box>
          </Box>
        </Box>

        {/* Text */}
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12.5px",
                fontWeight: 600,
                letterSpacing: ".2em",
                color: colors.steelBlue,
              }}
            >
              ABOUT ARGYLE
            </Box>
          </Box>
          <Box
            component="h2"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "clamp(30px,3.6vw,44px)",
              lineHeight: 1.1,
              letterSpacing: "-.02em",
              color: colors.navyInk,
              mt: "18px",
              mb: 0,
            }}
          >
            Building lasting value through expert advisory
          </Box>
          <Box
            sx={{
              fontFamily: fonts.body,
              fontSize: "16.5px",
              lineHeight: 1.7,
              color: colors.mutedText,
              mt: "20px",
            }}
          >
            Argyle Consulting is a professional consulting firm providing
            specialist strategy & management, corporate finance, financial
            advisory, human resource, risk & compliance, audit, technology, and
            property services to resident and non-resident companies in Nigeria,
            with a reach extending across West Africa and globally through
            affiliations and collaborations.
          </Box>
          <Box
            sx={{
              fontFamily: fonts.body,
              fontSize: "16.5px",
              lineHeight: 1.7,
              color: colors.mutedText,
              mt: "16px",
            }}
          >
            Our mission is to unlock your potential by delivering impactful,
            measurable results in every engagement: reliable, effective, and
            designed to meet your unique requirements.
          </Box>
          <Link
            href="/about-us"
            underline="none"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              mt: "26px",
              fontFamily: fonts.body,
              fontWeight: 700,
              color: colors.brandNavy,
              borderBottom: `2px solid ${colors.amber}`,
              pb: "4px",
            }}
          >
            Learn more about us <Box component="span">→</Box>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default About;
